import { GeneralOverviewPageRenderedComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import React from 'react';
import EsgOverviewTable from './components/EsgOverviewTable.component';
import { useSelector } from 'react-redux';
import { createSectionByIdSelector } from '../../../../redux/pages/selectors';
import { clientNameSelector } from '../../../../redux/auth/selectors';
import { raptorPlatformIdSelector } from '../../../../redux/raptorPlatform/selectors';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  useEsgOverviewMonitorQuery,
  type EsgOverviewPageModel,
} from '../../../../api/rs-hg/esg';
import { useReportsListQuery } from '../../../../api/rs-hg/risk/hooks/queries';

const EsgOverview: React.FC<GeneralOverviewPageRenderedComponentProps> = ({
  positionDate,
  section,
  pageId,
}) => {
  const sectionDetails = useSelector(createSectionByIdSelector(section));
  const clientName = useSelector(clientNameSelector);
  const fundTypes = sectionDetails?.fundTypes;
  const raptorPlatformId = useSelector(raptorPlatformIdSelector);
  const includeEsgReports = clientName?.includes('adepa') ?? false;

  const overviewQuery = useEsgOverviewMonitorQuery({
    positionDate,
    raptorPlatformId,
  });

  const esgReportsQuery = useReportsListQuery(
    {
      fundTypes,
      reportType: 'esg_report',
      raptorPlatformId,
    },
    { enabled: includeEsgReports && !!fundTypes },
  );

  return (
    <QueryBoundary<EsgOverviewPageModel>
      isLoading={overviewQuery.isLoading}
      isFetching={overviewQuery.isFetching}
      isError={overviewQuery.isError}
      error={overviewQuery.error}
      data={
        overviewQuery.data?.data?.overview_page_data?.length
          ? overviewQuery.data
          : null
      }
      loadingMessages={['Loading ESG Data...']}
      errorMessage="No ESG Data Found"
      noDataMessage="No ESG Data Found"
    >
      {(pageModel) => (
        <EsgOverviewTable
          pageModel={pageModel}
          esgReportsList={esgReportsQuery.data ?? {}}
          section={section}
          pageId={pageId}
        />
      )}
    </QueryBoundary>
  );
};

export default EsgOverview;
